module.exports = __webpack_public_path__ + "img/local_shipping.ebe34fa1.svg";